import React, { useCallback } from 'react'
import { setFormValues } from 'redux/slices/passTier'
import { choosePassTier } from 'redux/slices/passTier/thunks'

import CustomRadio from 'components/common/CustomRadio/CustomRadio'
import { Form } from 'data/Form'
import ImgWithFallback from 'components/common/ImgWithFallback/ImgWithFallback'
import { PassTier } from 'data/PassTier'
import { PassTierField } from 'components/set/PassTierField/PassTierField'
import clsx from 'clsx'
import numeral from 'numeral'
import { useDispatch } from 'react-redux'
import { useStyles } from './styles'

interface PassTierItemProps {
    passTier: PassTier
    isExpanded: boolean
    form: Form
    index: number
}

export const PassTierItem: React.FC<PassTierItemProps> = ({ passTier, isExpanded, form, index }) => {
    const classes = useStyles()
    const dispatch = useDispatch()

    const onItemClicked = useCallback(
        (event: React.ChangeEvent<{}>) => {
            if (!passTier.isSoldOut) {
                event.stopPropagation()
                if (!isExpanded) {
                    dispatch(setFormValues(form.values))
                    dispatch(choosePassTier(passTier))
                }
            }
        },
        [dispatch, isExpanded, passTier, form],
    )

    const amount = passTier.isSoldOut ? 'SOLD OUT' : numeral(passTier.amount).format('$0,0.00')

    return (
        <li className={classes.item}>
            <div onClick={onItemClicked} className={clsx(classes.tierWrapper, passTier.isSoldOut && classes.soldOut)}>
                <div className={classes.tierHeader}>
                    <span className={clsx(classes.priceImg, classes[`price${index + 1}`])} />
                    <div className={classes.contentWrapper}>
                        <div className={classes.amountAndCheck}>
                            <span className={classes.amount}>{amount}</span>
                            <CustomRadio
                                name="tier"
                                onClick={onItemClicked}
                                value={passTier._id}
                                checked={isExpanded}
                                className={passTier.isSoldOut ? classes.radioDisabled : ''}
                            />
                        </div>
                        <p className={classes.tierTitle}>{passTier.title}</p>
                    </div>
                </div>
                <ul className={classes.tierDescriptionItems}>
                    {passTier.descItems.map((item, index) => (
                        <li key={index}>• {item}</li>
                    ))}
                </ul>
            </div>
            {isExpanded && !passTier.isSoldOut && passTier.formGroups.length > 0 && (
                <ul className={classes.groups}>
                    {passTier.formGroups.map(group => (
                        <li key={group._id} className={classes.tierGroup}>
                            <h3 className={classes.groupTitle}>{group.title}</h3>
                            {group.fields.map(field => (
                                <div key={field._id}>
                                    {field.imgUrl && (
                                        <ImgWithFallback className={classes.img} src={field.imgUrl} alt="" />
                                    )}
                                    <PassTierField field={field} form={form} />
                                </div>
                            ))}
                        </li>
                    ))}
                </ul>
            )}
        </li>
    )
}

export default React.memo(PassTierItem)
